import { StepConnector, withStyles } from '@material-ui/core'

const FullHeightConnector = withStyles({
  root: { height: 22 },
  line: { height: 35, position: 'relative', top: -18, left: 0 }
})(StepConnector)

export default FullHeightConnector
